import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function H1Icon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4.26367 18H6.55167V13.36H11.2557V18H13.5597V6.56H11.2557V11.136H6.55167V6.56H4.26367V18Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17.9318 18H20.0278V6.832H18.3798C18.0758 8.544 16.8438 8.976 15.1478 9.008V10.592H17.9318V18Z",
    fill: "currentColor"
  }));
}